import React, { useCallback, useMemo, useState } from 'react';
import { DateUtils } from '@vectord/utils';

import BulkUpdateSuperBatchProjectsButton from '../BulkUpdateSuperBatchProjectsButton';
import DateTimeInput from 'components/DateTimeInput';
import Field from 'components/Field';
import Form from 'components/Form';
import styles from './EditSuperBatchProjectForm.module.scss';

export default function EditSuperBatchProjectForm({
  sbatGroup,
  handleModalClose,
  superBatchProject,
}) {
  const {
    end_time: sbatGroupProjectEndTime,
    start_time: sbatGroupProjectStartTime,
  } = superBatchProject || {};
  const { date_of_topic: dateOfTopic } = sbatGroup || {};

  const startTime = useMemo(() => {
    return new Date(sbatGroupProjectStartTime).getTime();
  }, [sbatGroupProjectStartTime]);

  const endTime = useMemo(() => {
    return new Date(sbatGroupProjectEndTime).getTime();
  }, [sbatGroupProjectEndTime]);

  const [superBatchProjectStartTime, setSuperBatchProjectStartTime] =
    useState(startTime);
  const [superBatchProjectEndTime, setSuperBatchProjectEndTime] =
    useState(endTime);

  const sbatGroupDateOfTopic = useMemo(() => {
    return new Date(dateOfTopic).getTime();
  }, [dateOfTopic]);

  const dateInputProps = useMemo(
    () => ({
      fromDate: sbatGroupDateOfTopic + DateUtils.ONE_DAY,
      // Allow schedule till max next 6 months from date_of_topic
      toDate: sbatGroupDateOfTopic + 180 * DateUtils.ONE_DAY,
      placement: 'top',
    }),
    [sbatGroupDateOfTopic]
  );

  const handleSuperBatchProjectStartTimeChange = useCallback((time) => {
    setSuperBatchProjectStartTime(time);
  }, []);

  const handleSuperBatchProjectEndTimeChange = useCallback((time) => {
    setSuperBatchProjectEndTime(time);
  }, []);

  return (
    <Form>
      <div className="row wrap m-t-xxs">
        <Field
          label="Start Date"
          className={styles.dateInputField}
        >
          <DateTimeInput
            value={superBatchProjectStartTime}
            onChange={handleSuperBatchProjectStartTimeChange}
            dateInputProps={dateInputProps}
          />
        </Field>
        <Field
          label="End Date"
          className={styles.dateInputField}
        >
          <DateTimeInput
            value={superBatchProjectEndTime}
            onChange={handleSuperBatchProjectEndTimeChange}
            dateInputProps={dateInputProps}
          />
        </Field>
      </div>
      <BulkUpdateSuperBatchProjectsButton
        sbatGroup={sbatGroup}
        handleModalClose={handleModalClose}
        superBatchProject={superBatchProject}
        superBatchProjectEndTime={superBatchProjectEndTime}
        superBatchProjectStartTime={superBatchProjectStartTime}
      />
    </Form>
  );
}
